import { Routes } from '@angular/router';

import { cipAuthenticatedRouteGuard } from '@mobi/rwc-utils-authentication-jslib';

export const routes: Routes = [
  {
    path: 'home',
    loadChildren: () => import('./features/home/home.routes'),
  },
  {
    path: 'protected',
    loadChildren: () => import('./features/protected/protected.routes'),
    canMatch: [cipAuthenticatedRouteGuard],
  },
  {
    path: 'login',
    loadChildren: () => import('./features/loggedin/loggedin.routes'),
  },
  { path: '**', redirectTo: 'home' },
];
